

export const appPlacementTypes = {
    LIBRARY_MEDIAS_MEDIA_DETAIL: 'LIBRARY.MEDIAS.MEDIA.DETAIL',
    LIBRARY_MEDIAS_LIVE_DETAIL: 'LIBRARY.MEDIAS.LIVE.DETAIL',
    LIBRARY_CATALOGS_CATALOG_DETAIL: 'LIBRARY.CATALOGS.CATALOG.DETAIL',
    LIBRARY_PLAYLISTS_PLAYLIST_DETAIL: 'LIBRARY.PLAYLISTS.PLAYLIST.DETAIL',
    TOPMENU: 'TOPMENU',
    LEFTMENU: 'LEFTMENU',
};